import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import MediaSelector from '../../ai-studio/media-selector/MediaSelector';
import TagsOutput from './components/tag-output/TagsOutput';
import MediaGallery from '../../ai-studio/media-gallery/MediaGallery';
import ActionsBlock from './components/actions-block/ActionsBlock';
import MediaSelectSlide from './components/media-select-slide/MediaSelectSlide';
import usePredefineOptions from './hooks/usePredefineOptions';
import CommonTabs from '../../components/common-tabs/CommonTabs';
import CommonTabPanel from '../../components/common-tabs/CommonTabPanel';
import useMediaContentTabs from './hooks/useMediaContentTabs';
import { changeStudioTab } from '../../redux/ai-studio/aiStudioReducer';
import { AI_STUDIO_TABS, PROJECT_VARIANTS } from '../../constants';
import FavoriteMedia from '../../ai-studio/favorite-media/FavoriteMedia';
import { ProjectProvider } from '../../context/ProjectContext';
import useAdditionalFavoriteCardActions from './hooks/useAdditionalFavoriteCardActions';

import scss from './Studio.module.scss';
import useAdditionalGeneratedCardActions from './hooks/useAdditionalGeneratedCardActions';

function Studio() {
  const dispatch = useDispatch();

  const TABS = useMediaContentTabs();
  const studioTab = useSelector((state) => state.aiStudio.studioTab);

  const actionOptions = usePredefineOptions();
  const additionalFavoriteCardActions = useAdditionalFavoriteCardActions();
  const additionalGeneratedCardActions = useAdditionalGeneratedCardActions();

  const handleChangeStudioTab = (_, newTab) => {
    dispatch(changeStudioTab(newTab));
  };

  useEffect(() => {
    return () => {
      dispatch(changeStudioTab(AI_STUDIO_TABS.GENERATED));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ProjectProvider projectType='AI_STUDIO' projectVariant={PROJECT_VARIANTS.ADMIN}>
      <div className={scss.wrapper}>
        <MediaSelector
          style={{ gridArea: 'mediaSelector' }}
          AdditionalContent={TagsOutput}
          Slide={MediaSelectSlide}
          isVideoEnabled
        />

        <div style={{ gridArea: 'mediaGallery' }} className={scss.mediaGallery}>
          <CommonTabs tabs={TABS} value={studioTab} onChange={handleChangeStudioTab} isFullWidth />
          <CommonTabPanel className={scss.tabsWrapper} value={studioTab} index={AI_STUDIO_TABS.GENERATED}>
            <MediaGallery
              actionOptions={actionOptions.options}
              additionalCardActions={additionalGeneratedCardActions}
            />
          </CommonTabPanel>
          <CommonTabPanel className={scss.tabsWrapper} value={studioTab} index={AI_STUDIO_TABS.FAVORITES}>
            <FavoriteMedia additionalCardActions={additionalFavoriteCardActions} />
          </CommonTabPanel>
        </div>

        <ActionsBlock style={{ gridArea: 'actions' }} />
      </div>
    </ProjectProvider>
  );
}

export default Studio;
